<img class="icon open-icon" src="/content/icons/open-new-page.svg" (click)="getAndOpenInvoicePDF(invoiceDocumentId)">
